import React from 'react';
import classNames from 'classnames';

import filterList from '../../../utils/filter';

import CompanySize from './companySize';
import CompanyType from './companyType';
import Industries from './industries';

import classes from './employmentStatistics.module.css';

const EmploymentStatistics = ({
  jobTitle,
  demographicsData,
  articles,
  criteria,
  filterLogEventCallback,
  jobTitlePlural,
}) => {
  const { companySizes, companyTypes, industries } = demographicsData;

  const companySizesPresent = companySizes && companySizes.range && companySizes.range.length;

  const companyTypesPresent = companyTypes && companyTypes.range && companyTypes.range.length;

  const industriesPresent = industries && industries.range && industries.range.length;

  const employementContentBlurb = articles.find(
    (article) => article.post_subtype === 'employment-section'
  );

  const companySizeContentBlurb = articles.find(
    (article) => article.post_subtype === 'company-size-section'
  );

  const companyTypeContentBlurb = articles.find(
    (article) => article.post_subtype === 'company-type-section'
  );

  const industryContentBlurb = articles.find(
    (article) => article.post_subtype === 'industry-concentration-section'
  );

  const { relatedTitles } = criteria;

  const relatedTitlesValueRange =
    relatedTitles && relatedTitles.length > 0 ? filterList.compareJobs(relatedTitles) : [];

  if (
    !employementContentBlurb &&
    !companySizesPresent &&
    !companyTypesPresent &&
    !industriesPresent
  ) {
    return null;
  }

  return (
    <>
      <section
        id="employement-statistics"
        className={classNames(classes['employement-statistics-container'], 'w-730')}
      >
        <h2 className="brandonH2 z-mb-48 w-730">{`${jobTitle} employment statistics`}</h2>
        {employementContentBlurb && employementContentBlurb.content && (
          <div
            className="mb-5 w-730"
            dangerouslySetInnerHTML={{ __html: employementContentBlurb.content }}
          />
        )}
        {companySizesPresent && (
          <CompanySize
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={relatedTitlesValueRange}
            companySizes={companySizes.range}
            jobTitle={jobTitle}
            companySizeContentBlurb={companySizeContentBlurb}
            jobTitlePlural={jobTitlePlural}
          />
        )}
        {companyTypesPresent && (
          <CompanyType
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={relatedTitlesValueRange}
            companyTypes={companyTypes.range}
            jobTitle={jobTitle}
            companyTypeContentBlurb={companyTypeContentBlurb}
          />
        )}
        {industriesPresent && (
          <Industries
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={relatedTitlesValueRange}
            industries={industries.range}
            jobTitle={jobTitle}
            jobTitlePlural={jobTitlePlural}
            industryContentBlurb={industryContentBlurb}
          />
        )}
      </section>
      <div className="section-separator-large-full-width" />
    </>
  );
};

export default EmploymentStatistics;
